var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Box, Paper, FormControl, InputLabel, Select, MenuItem, TextField, Button, Typography, } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import FilterListIcon from '@mui/icons-material/FilterList';
import { makeStyles } from 'tss-react/mui';
import { useAppSelector } from 'hooks/reduxHooks';
import { Roles } from 'globals/enums';
var BPO_ALLOWED_CALL_TYPES = ['All', 'Fall Detected', 'SOS'];
var FACILITY_AGENT_CALL_TYPES = [
    'All',
    'SOS',
    'Fall Detected',
    'Emergency Room Visit',
    'Hospitalization',
];
var CALL_TYPE_OPTIONS = [
    'All',
    'Senior Onboarding',
    'Caregiver Onboarding',
    'Senior Check-in',
    'Caregiver Check-in',
    'Return Call',
    'Agency follow-up',
    'Fall Detected',
    'SOS',
    'Care Coordination',
    'Care Insight Notification',
    'Hospitalization',
    'Emergency Room Visit',
    'Other',
];
var CALL_DIRECTION_OPTIONS = ['All', 'Inbound', 'Outbound'];
var CONTROL_HEIGHT = 40;
var useStyles = makeStyles()(function () { return ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: '14px 20px',
        marginBottom: 16,
        borderRadius: 10,
        border: '1px solid #E0E5E9',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 1px 3px rgba(16, 24, 40, 0.06)',
    },
    controlsRow: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: 10,
        width: '100%',
        minWidth: 0,
    },
    actionsRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8,
        width: '100%',
    },
    labelGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        color: '#32602F',
        marginRight: 4,
        flexShrink: 0,
    },
    labelIcon: {
        fontSize: 20,
    },
    labelText: {
        fontWeight: 600,
        fontSize: 14,
        whiteSpace: 'nowrap',
    },
    divider: {
        width: 1,
        height: 32,
        backgroundColor: '#E0E5E9',
        flexShrink: 0,
    },
    field: {
        flex: '1 1 120px',
        minWidth: 120,
        maxWidth: 170,
        '& .MuiOutlinedInput-root': {
            height: CONTROL_HEIGHT,
            borderRadius: 8,
            backgroundColor: '#F8FAF8',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5DBD5',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#32602F',
        },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#32602F',
        },
    },
    callTypeField: {
        flex: '1 1 150px',
        minWidth: 150,
        maxWidth: 220,
        '& .MuiOutlinedInput-root': {
            height: CONTROL_HEIGHT,
            borderRadius: 8,
            backgroundColor: '#F8FAF8',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5DBD5',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#32602F',
        },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#32602F',
        },
    },
    dateGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexShrink: 1,
        minWidth: 0,
    },
    dateField: {
        flex: '1 1 120px',
        minWidth: 120,
        maxWidth: 165,
        '& .MuiOutlinedInput-root': {
            height: CONTROL_HEIGHT,
            borderRadius: 8,
            backgroundColor: '#F8FAF8',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5DBD5',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#32602F',
        },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#32602F',
        },
        '& input': {
            padding: '8.5px 10px',
            cursor: 'pointer',
        },
    },
    clearButton: {
        height: CONTROL_HEIGHT,
        color: '#32602F',
        borderColor: '#32602F',
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        '&:hover': {
            borderColor: '#244022',
            backgroundColor: 'rgba(50, 96, 47, 0.04)',
        },
    },
    applyButton: {
        height: CONTROL_HEIGHT,
        backgroundColor: '#32602F',
        color: '#FFFFFF',
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        boxShadow: 'none',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        '&:hover': {
            backgroundColor: '#244022',
            boxShadow: 'none',
        },
    },
    errorText: {
        color: '#d32f2f',
        fontSize: 12,
        marginTop: -4,
        whiteSpace: 'nowrap',
    },
}); });
var DEFAULT_FILTER_VALUE = {
    callType: 'All',
    callDirection: 'All',
    startDate: '',
    endDate: '',
};
var blockManualEntry = {
    onKeyDown: function (e) { return e.preventDefault(); },
    onPaste: function (e) { return e.preventDefault(); },
};
var SeniorCallLogsFilter = function (_a) {
    var _b, _c, _d, _e;
    var disabled = _a.disabled, initialValue = _a.initialValue, onChange = _a.onChange, _f = _a.careAgent, careAgent = _f === void 0 ? 'All' : _f, _g = _a.careAgentOptions, careAgentOptions = _g === void 0 ? ['All'] : _g, onCareAgentChange = _a.onCareAgentChange;
    var classes = useStyles().classes;
    var userRole = useAppSelector(function (state) { return state.auth.roleConfig.role; });
    var callTypeOptions = React.useMemo(function () {
        var roles = Array.isArray(userRole) ? userRole : [userRole];
        if (roles.includes(Roles.FACILITY_AGENT)) {
            return CALL_TYPE_OPTIONS.filter(function (option) {
                return FACILITY_AGENT_CALL_TYPES.includes(option);
            });
        }
        if (roles.includes(Roles.BPO_CareUser)) {
            return CALL_TYPE_OPTIONS.filter(function (option) {
                return BPO_ALLOWED_CALL_TYPES.includes(option);
            });
        }
        return CALL_TYPE_OPTIONS;
    }, [userRole]);
    var _h = useState((_b = initialValue === null || initialValue === void 0 ? void 0 : initialValue.callType) !== null && _b !== void 0 ? _b : DEFAULT_FILTER_VALUE.callType), callType = _h[0], setCallType = _h[1];
    var _j = useState((_c = initialValue === null || initialValue === void 0 ? void 0 : initialValue.callDirection) !== null && _c !== void 0 ? _c : DEFAULT_FILTER_VALUE.callDirection), callDirection = _j[0], setCallDirection = _j[1];
    var _k = useState((_d = initialValue === null || initialValue === void 0 ? void 0 : initialValue.startDate) !== null && _d !== void 0 ? _d : DEFAULT_FILTER_VALUE.startDate), appliedStartDate = _k[0], setAppliedStartDate = _k[1];
    var _l = useState((_e = initialValue === null || initialValue === void 0 ? void 0 : initialValue.endDate) !== null && _e !== void 0 ? _e : DEFAULT_FILTER_VALUE.endDate), appliedEndDate = _l[0], setAppliedEndDate = _l[1];
    var _m = useState(appliedStartDate), startDate = _m[0], setStartDate = _m[1];
    var _o = useState(appliedEndDate), endDate = _o[0], setEndDate = _o[1];
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (!initialValue)
            return;
        setCallType((_a = initialValue.callType) !== null && _a !== void 0 ? _a : DEFAULT_FILTER_VALUE.callType);
        setCallDirection((_b = initialValue.callDirection) !== null && _b !== void 0 ? _b : DEFAULT_FILTER_VALUE.callDirection);
        setAppliedStartDate((_c = initialValue.startDate) !== null && _c !== void 0 ? _c : DEFAULT_FILTER_VALUE.startDate);
        setAppliedEndDate((_d = initialValue.endDate) !== null && _d !== void 0 ? _d : DEFAULT_FILTER_VALUE.endDate);
        setStartDate((_e = initialValue.startDate) !== null && _e !== void 0 ? _e : DEFAULT_FILTER_VALUE.startDate);
        setEndDate((_f = initialValue.endDate) !== null && _f !== void 0 ? _f : DEFAULT_FILTER_VALUE.endDate);
    }, [initialValue]);
    var dateRangeInvalid = !!startDate && !!endDate && new Date(startDate) > new Date(endDate);
    var hasPendingDateChange = startDate !== appliedStartDate || endDate !== appliedEndDate;
    var hasAnyDateValue = !!startDate || !!endDate || !!appliedStartDate || !!appliedEndDate;
    var handleCallTypeChange = function (e) {
        var value = e.target.value;
        setCallType(value);
        onChange === null || onChange === void 0 ? void 0 : onChange({
            callType: value,
            callDirection: callDirection,
            startDate: appliedStartDate,
            endDate: appliedEndDate,
        });
    };
    var handleCallDirectionChange = function (e) {
        var value = e.target.value;
        setCallDirection(value);
        onChange === null || onChange === void 0 ? void 0 : onChange({
            callType: callType,
            callDirection: value,
            startDate: appliedStartDate,
            endDate: appliedEndDate,
        });
    };
    var handleCareAgentChange = function (e) {
        onCareAgentChange === null || onCareAgentChange === void 0 ? void 0 : onCareAgentChange(e.target.value);
    };
    var handleStartDateChange = function (newValue) {
        setStartDate(newValue && newValue.isValid() ? newValue.format('YYYY-MM-DD') : '');
    };
    var handleEndDateChange = function (newValue) {
        setEndDate(newValue && newValue.isValid() ? newValue.format('YYYY-MM-DD') : '');
    };
    var handleApplyDates = function () {
        if (dateRangeInvalid)
            return;
        setAppliedStartDate(startDate);
        setAppliedEndDate(endDate);
        onChange === null || onChange === void 0 ? void 0 : onChange({ callType: callType, callDirection: callDirection, startDate: startDate, endDate: endDate });
    };
    var handleClearDates = function () {
        setStartDate('');
        setEndDate('');
        setAppliedStartDate('');
        setAppliedEndDate('');
        onChange === null || onChange === void 0 ? void 0 : onChange({ callType: callType, callDirection: callDirection, startDate: '', endDate: '' });
    };
    return (_jsxs(Paper, { elevation: 0, className: classes.paper, "data-testid": "call-logs-filter", children: [_jsxs(Box, { className: classes.controlsRow, children: [_jsxs(Box, { className: classes.labelGroup, children: [_jsx(FilterListIcon, { className: classes.labelIcon }), _jsx(Typography, { className: classes.labelText, children: "Filters" })] }), _jsx(Box, { className: classes.divider }), _jsxs(FormControl, { className: classes.callTypeField, size: "small", children: [_jsx(InputLabel, { id: "call-type-label", children: "Call Type" }), _jsx(Select, { labelId: "call-type-label", label: "Call Type", value: callType, onChange: handleCallTypeChange, "data-testid": "callTypeFilter", children: callTypeOptions.map(function (option) { return (_jsx(MenuItem, { value: option, children: option }, option)); }) })] }), _jsxs(FormControl, { className: classes.field, size: "small", children: [_jsx(InputLabel, { id: "call-direction-label", children: "Call Direction" }), _jsx(Select, { labelId: "call-direction-label", label: "Call Direction", value: callDirection, onChange: handleCallDirectionChange, "data-testid": "callDirectionFilter", children: CALL_DIRECTION_OPTIONS.map(function (option) { return (_jsx(MenuItem, { value: option, children: option }, option)); }) })] }), _jsxs(FormControl, { className: classes.callTypeField, size: "small", children: [_jsx(InputLabel, { id: "care-agent-label", children: "Agent" }), _jsx(Select, { labelId: "care-agent-label", label: "Care Agent", value: careAgentOptions.includes(careAgent) ? careAgent : 'All', onChange: handleCareAgentChange, "data-testid": "careAgentFilter", children: careAgentOptions.map(function (option) { return (_jsx(MenuItem, { value: option, children: option }, option)); }) })] }), _jsx(Box, { className: classes.divider }), _jsx(LocalizationProvider, { dateAdapter: AdapterMoment, children: _jsxs(Box, { className: classes.dateGroup, children: [_jsx(DatePicker, { label: "Start Date", value: startDate ? moment(startDate) : null, onChange: handleStartDateChange, disabled: disabled, maxDate: endDate ? moment(endDate) : undefined, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { size: "small", className: classes.dateField, error: dateRangeInvalid, inputProps: __assign(__assign({}, params.inputProps), { readOnly: true, 'data-testid': 'callLogsStartDate' }), onKeyDown: function (e) { return e.preventDefault(); }, onPaste: function (e) { return e.preventDefault(); } }))); } }), _jsx(DatePicker, { label: "End Date", value: endDate ? moment(endDate) : null, onChange: handleEndDateChange, disabled: disabled, minDate: startDate ? moment(startDate) : undefined, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { size: "small", className: classes.dateField, error: dateRangeInvalid, inputProps: __assign(__assign({}, params.inputProps), { readOnly: true, 'data-testid': 'callLogsEndDate' }), onKeyDown: function (e) { return e.preventDefault(); }, onPaste: function (e) { return e.preventDefault(); } }))); } })] }) })] }), _jsxs(Box, { className: classes.actionsRow, children: [_jsx(Button, { variant: "outlined", className: classes.clearButton, onClick: handleClearDates, disabled: disabled || !hasAnyDateValue, "data-testid": "callLogsFilterClear", children: "Clear Dates" }), _jsx(Button, { variant: "contained", className: classes.applyButton, onClick: handleApplyDates, disabled: disabled || dateRangeInvalid || !hasPendingDateChange, "data-testid": "callLogsFilterApply", children: "Apply Dates" })] }), dateRangeInvalid && (_jsx(Typography, { className: classes.errorText, children: "End date must be after start date" }))] }));
};
export default SeniorCallLogsFilter;
